// import React from "react";
import React, { useState, useEffect } from "react";
import { useStore } from "effector-react";
import { $seatedGuests } from "../store/guestsStore";
import SeatedGuestCard from "./SeatedGuestCard";
import "./SeatedGuests.css";

const SeatedGuests = () => {
  const [_, setRerender] = useState(0); // 🔥 State for forcing re-render
  const seatedGuests = useStore($seatedGuests).sort((a, b) => {
    const now = Date.now();
    const aTimeLeft = a.seatedAt + 300000 - now;
    const bTimeLeft = b.seatedAt + 300000 - now;

    if (aTimeLeft <= 0 && bTimeLeft > 0) return -1;
    if (bTimeLeft <= 0 && aTimeLeft > 0) return 1;
    return aTimeLeft - bTimeLeft;
  });

  // 🔥 Expose function globally so we can trigger re-render from anywhere
  window.triggerSeatedGuestsRerender = () => setRerender((prev) => prev + 1);

  return (
    <div className="seated-guests-container">
      <h3 className="seated-guests-title">Посаженные гости</h3>
      <div className="seated-guests-list">
        {seatedGuests.map((guest) => (
          <SeatedGuestCard key={guest.id} guest={guest} />
        ))}
      </div>
    </div>
  );
};

export default SeatedGuests;
